import { Aurelia, autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { Config } from 'Config';

@autoinject
@customElement('header-wrapper')
export class HeaderWrapper {
    private authService: AuthService = null;
    protected dataService: DataService = null;
    protected ea: EventAggregator = null;
    protected router: Router = null;
    protected element: any = null;

    private filter1Name: string = null;
    private userName: string = null;
    private isLogged: boolean = false;

    constructor(dataService: DataService, authService: AuthService, eventAggregator: EventAggregator, router: Router, element: Element) {
        this.dataService = dataService;
        this.authService = authService;
        this.ea = eventAggregator;
        this.router = router;
        this.element = element;

        this.userName = this.authService.GetUserInfo().UserName;
        this.isLogged = StringHelper.StringIs(this.userName) && this.userName != 'PublicUser';
    }

    async bind() {

    }

    async Filter1() {
        let data1: any = {};
        data1.FilterString = StringHelper.StringIs(this.filter1Name) ? this.filter1Name : '';

        if (this.router.currentInstruction.config.name != 'dashboard') {
            SystemService.Instance.SetStorageItem(null, 'Filter1String', data1.FilterString);
            this.router.navigateToRoute('dashboard');
        }
        else {
            this.ea.publish('filter1', data1);
        }
    }
}